import React from "react";

function ItineraryIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 4C21 4.55228 20.5523 5 20 5C19.4477 5 19 4.55228 19 4C19 3.44772 19.4477 3 20 3C20.5523 3 21 3.44772 21 4ZM23 4C23 5.65685 21.6569 7 20 7C18.6938 7 17.5825 6.16519 17.1707 5H7C5.34315 5 4 6.34315 4 8C4 9.65685 5.34315 11 7 11H9.17071C9.58254 9.83481 10.6938 9 12 9C13.3062 9 14.4175 9.83481 14.8293 11H17C19.7614 11 22 13.2386 22 16C22 18.7614 19.7614 21 17 21H6.82929C6.41746 22.1652 5.30622 23 4 23C2.34315 23 1 21.6569 1 20C1 18.3431 2.34315 17 4 17C5.30622 17 6.41746 17.8348 6.82929 19H17C18.6569 19 20 17.6569 20 16C20 14.3431 18.6569 13 17 13H14.8293C14.4175 14.1652 13.3062 15 12 15C10.6938 15 9.58254 14.1652 9.17071 13H7C4.23858 13 2 10.7614 2 8C2 5.23858 4.23858 3 7 3H17.1707C17.5825 1.83481 18.6938 1 20 1C21.6569 1 23 2.34315 23 4ZM5 20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19C4.55228 19 5 19.4477 5 20ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                fill="#505050"
            />
        </svg>
    );
}

export default ItineraryIcon;
